import markdownIt from 'markdown-it';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(markdownIt)
})
